<script setup>
import { reactive, watch, ref } from 'vue';
import { http } from '@/plugins/http';
import VSelect from '@/components/Common/VSelect.vue';
import VInput from '@/components/Common/VInput.vue';
import CarItem from '@/components/MainFilter/CarItem.vue';

const props = defineProps({
  cars: {
    type: Array,
    default: () => [],
  },

  filterData: {
    type: Object,
    default: () => ({}),
  },

  lastPageInitial: {
    type: String,
    default: '0',
  }
});

const currentPage = ref(1);
const currentLastPage = ref(Number(props.lastPageInitial));
const timer = ref(null);

const selectedFilter = reactive({
  brands: [],
  models: [],
  price_min: null,
  price_max: null,
});

const filterDataLocal = ref(props.filterData);
const carsLocal = ref(props.cars);

const urlParams = (selectedLocal) => {
  let params = '';

  for (let options in selectedLocal) {
    if (selectedLocal[options] instanceof Array) {
      selectedLocal[options].forEach(item => {
        params += `&${options}[]=${item.id}`;
      });
    };

    if (typeof selectedLocal[options] === 'number') {
      params += `&${options}=${selectedLocal[options]}`
    }
  };

  return params.length ? `${encodeURI(params)}` : '';
};

const fetchFilter = (params, page, showMore) => {
  http
    .get(`/filter/stock/page/${page}/?stock=cars-order${urlParams(params)}`)
    .then(resp => {
      carsLocal.value = showMore ? [...carsLocal.value, ...resp.data.cars] : [...resp.data.cars];
      currentLastPage.value = resp.data.last_page;
    })
    .catch(error => {
      return Promise.reject({
        error,
      });
    });
};

const fetchFilterParams = (params) => {
  http
    .get(`/filter/params/?stock=cars-order${urlParams(params)}`)
    .then(resp => {
      if (resp.data) {
        filterDataLocal.value = {...resp.data};
        return;
      }

      filterDataLocal.value = {...props.filterData};
    })
    .catch(error => {
      return Promise.reject({
        error,
      });
    });
};

watch(selectedFilter, (newValue) => {
  clearTimeout(timer.value);

  timer.value = setTimeout(() => {
    currentPage.value = 1;
    fetchFilterParams(newValue);
    fetchFilter(newValue, currentPage.value);
  }, 500);
});
</script>

<template>
  <div class="flex flex-col lg:flex-row justify-between items-center py-3 md:py-6 px-4 md:px-8 bg-white rounded-md">
    <div class="text-gray-800 mb-5 lg:mb-0 font-medium text-lg md:mr-10 lg:mr-24">Фильтр</div>
    <div class="grid grid-cols-1 md:grid-cols-[3fr,3fr,4fr] gap-3 md:gap-6 w-full">
      <VSelect
        v-model="selectedFilter.brands"
        theme="white"
        placeholder="Марка"
        :options="filterDataLocal.brands"
        multiple
      />

      <VSelect
        v-model="selectedFilter.models"
        theme="white"
        placeholder="Модель"
        :options="filterDataLocal.models"
        multiple
      />

      <div class="flex w-full">
        <VInput
          v-model="selectedFilter.price_min"
          theme="white"
          placeholder="Цена от, ₽"
          format="price"
          class="w-full"
          classes-input="!rounded-r-none"
        />

        <VInput
          v-model="selectedFilter.price_max"
          theme="white"
          placeholder="до"
          format="price"
          class="w-full"
          classes-input="!rounded-l-none"
        />
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-y-10 gap-x-6">
    <CarItem
      v-if="carsLocal?.length >= 1"
      v-for="(car, index) of carsLocal"
      :key="index"
      :car="car"
      card-type="secondary"
    />

    <div 
      v-else 
      class="mt-5"
    >
      По вашему запросу ничего не найдено
    </div>
  </div>

<div class="flex w-full justify-center">
  <button
    v-if="currentPage < currentLastPage"
    class="button button_white mt-5 md:mt-7 button_big w-full mx-auto md:w-64 h-16 rounded-md"
    @click="fetchFilter(selectedFilter, ++currentPage, true);"
  >
    Смотреть ещё
  </button>
</div>

</template>